import { cartAxiosInstance as network } from '../../axios';
import { Endpoints, SiteTypes } from '../../enums';
import { CartUserReplacementResponse } from '../../types';
import { endpointReplace } from '../../utils/endpointReplace';

export const postUserReplacement = async (userId: string) => {
  const path = endpointReplace({ ':siteType': SiteTypes.CART }, Endpoints.PostCartUserReplacement);
  const authentication = await globalThis.ikea.mvAgent.authentication?.isLoggedIn();

  const response = await network.post<CartUserReplacementResponse>(
    path,
    {
      userId: userId,
      userSource: 'irw',
    },
    {
      ...((authentication?.authToken ?? authentication?.guestToken) && {
        headers: {
          'x-auth-token': authentication.authToken ?? authentication.guestToken,
        },
      }),
    },
  );

  return response.data;
};
